import { combineReducers } from "redux";
import { orgsState } from "./orgsReducer";

export const orgsReducers = combineReducers({
  orgsState: orgsState
});
